import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import MessagesContainer from '../../Messages/MessagesContainer'
import css from './conversation-list-item.css'
import { choosePhoneNumberFormatter } from '../../../services/formatters'

const cx = classNames.bind(css)
const headerText = (conv, countryCode) => {
  if (conv.messages_type === 'text') {
    const formattedPatientPhone = choosePhoneNumberFormatter(countryCode)(
      conv.patient_phone,
    )
    const formattedPracticePhone = choosePhoneNumberFormatter(countryCode)(
      conv.practice_phone,
    )
    return (
      <span>
        <strong>Patient:</strong> {`${formattedPatientPhone}`} •{' '}
        <strong>Practice:</strong> {`${formattedPracticePhone}`}
      </span>
    )
  }
  return conv.subject || conv.created_at
}

const ConversationListItem = ({
  conversation,
  conversationById,
  countryCode,
  handleSelectConvo,
  handleMessageFocus,
  isEmail,
  isSelected,
  messages,
  selectedMessageId,
  hasRemindersTier2,
  attachedMedia,
  previewPendingMedia,
}) => (
  <div className={cx(css.wrapper, { [css.selected]: isSelected })}>
    <div
      className={css.header}
      role="button"
      tabIndex="-1"
      onClick={() => handleSelectConvo(isSelected ? null : conversation.id)}
    >
      <h5 className={cx(css.subject, { [css.textSubject]: !isEmail })}>
        {headerText(conversation, countryCode)}
      </h5>
    </div>
    {isSelected && (
      <MessagesContainer
        key="messages"
        conversationById={conversationById}
        handleMessageFocus={handleMessageFocus}
        isEmail={isEmail}
        isBlastMsg={false}
        isDrafting={false}
        isEditorFocused={false}
        isSending={false}
        messages={messages}
        selectedMessageId={selectedMessageId}
        hasRemindersTier2={hasRemindersTier2}
        attachedMedia={attachedMedia}
        previewPendingMedia={previewPendingMedia}
      />
    )}
  </div>
)

ConversationListItem.propTypes = {
  conversation: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  conversationById: PropTypes.objectOf(
    PropTypes.shape({
      active: PropTypes.bool,
      created_at: PropTypes.string,
      id: PropTypes.number,
      patients: PropTypes.arrayOf(
        PropTypes.shape({
          first_name: PropTypes.string,
          last_name: PropTypes.string,
        }),
      ),
      seen: PropTypes.bool,
      subject: PropTypes.string,
      updated_at: PropTypes.string,
    }),
  ),
  countryCode: PropTypes.string,
  handleSelectConvo: PropTypes.func.isRequired,
  handleMessageFocus: PropTypes.func.isRequired,
  isEmail: PropTypes.bool,
  isSelected: PropTypes.bool.isRequired,
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    }),
  ).isRequired,
  selectedMessageId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
    .isRequired,
  hasRemindersTier2: PropTypes.bool.isRequired,
}

export default ConversationListItem



// WEBPACK FOOTER //
// ./src/components/PatientPage/Messages/ConversationListItem.js